import React from 'react';

interface DataContext {
  drupalData: Queries.paragraph__text;
  additionalData: {
    allFiles: Queries.file__file[];
  };
}

export default function Text({drupalData, additionalData}: DataContext): React.JSX.Element {
  let body = drupalData.field_body?.processed || '';

  // Ensure all links are https
  body = body.replaceAll('http://', 'https://');

  const drupalLink = process.env.DRUPAL_SOURCE;
  const absoluteDrupalLinks = body.match(new RegExp(`${drupalLink}[^"]*`, 'g')) || [];
  const relativeDrupalLinks = body.match(new RegExp('/sites/default/files[^"]*', 'g')) || [];
  absoluteDrupalLinks.concat(relativeDrupalLinks).forEach((link: string): void => {
    const file = additionalData.allFiles.find((f) => f.publicUrl.includes(encodeURIComponent(link)));
    if (file) body = body.replaceAll(link, file.publicUrl);
  });

  return (
    <section className="vl-region vl-image--height-auto vl-table--auto-scale">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          <div className="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s">
            <div
              className="vl-typography"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
